import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import CapiSettingsAPI from './api';

/**
 * Before resolving a conversation, make sure the Click-to-WhatsApp lead outcome was reported
 * when the conversation's channel requires it. Returns a promise<boolean>: true = proceed.
 * The backend enforces the same rule; this only gives the agent a dialog instead of an error.
 */
export function useCapiResolveGuard(dialogRef) {
  const { t } = useI18n();

  const ensureCapiOutcome = async conversationId => {
    try {
      const { data } = await CapiSettingsAPI.conversationStatus(conversationId);
      if (!data.require_before_resolve) return true;
      if (!data.ctwa || data.resolve_allowed) return true;
      if (!dialogRef?.value || !data.pending_message_id) {
        useAlert(t('WASAPI_CAPI.RESOLVE_BLOCKED_DESCRIPTION'));
        return false;
      }
      return dialogRef.value.open({
        conversationId,
        messageId: data.pending_message_id,
        outcomeOptions: data.required_outcome_options || [],
      });
    } catch {
      // never block resolving on a guard failure; the backend still enforces the rule
      return true;
    }
  };

  return { ensureCapiOutcome };
}
